const BASE_PATH = 'api/progress/'

const types = {
  PROGRESS_FETCH_REQUEST: BASE_PATH + 'PROGRESS_FETCH_REQUEST',
  PROGRESS_FETCH_FAILURE: BASE_PATH + 'PROGRESS_FETCH_FAILURE',
  PROGRESS_FETCH_SUCCESS: BASE_PATH + 'PROGRESS_FETCH_SUCCESS'
}

export default types